module.exports = __webpack_public_path__ + "notepad.f2c22cd3d03df50a72afecf7c1eb58fc.svg";